module.exports = {
  NO_TYPE: 0,
  REVERSE_IT: 1,
  SWAP_IT: 2,
};
